import React, { createContext, FC } from 'react';
import { useParams } from 'react-router-dom';

import { ClientGroupSourceFragment, useGetGroupSourcesQuery } from 'api';
import { useNotify } from 'hooks';

interface ISourcesData {
  isLoading: boolean;
  sources: ClientGroupSourceFragment[];
}

const GroupSourcesContext = createContext<ISourcesData>({
  isLoading: false,
  sources: [],
});

const GroupSourcesProvider: FC = ({ children }) => {
  const notify = useNotify();
  const { group_id } = useParams<{ group_id: string }>();

  const { data, isLoading } = useGetGroupSourcesQuery(
    { group_id },
    {
      onError: notify.queryError,
    }
  );

  const sources = data?.getClientGroupSourcesByGroup ?? [];

  return (
    <GroupSourcesContext.Provider value={{ sources, isLoading }}>
      {children}
    </GroupSourcesContext.Provider>
  );
};

export { GroupSourcesContext, GroupSourcesProvider };
